import { cn } from '@/lib/cn';

interface MashrabiyaPatternProps {
  className?: string;
  /** Tailwind color class for `text-*` so `currentColor` cascades. */
  tone?: string;
}

/**
 * Radial-dot lattice texture used as low-opacity background overlay.
 * Apply on a positioned ancestor (e.g. with `relative`) and let this fill it.
 */
export function MashrabiyaPattern({
  className,
  tone = 'text-primary/5',
}: MashrabiyaPatternProps) {
  return (
    <div
      aria-hidden="true"
      className={cn('mashrabiya-pattern pointer-events-none absolute inset-0', tone, className)}
    />
  );
}
